import { AlertTriangle, CheckCircle2, Info, OctagonAlert, PauseCircle, Wrench } from "lucide-react";

export const STATUS = {
  running: {
    label: "I drift",
    icon: CheckCircle2,
    text: "text-foreground",
    badge: "text-foreground",
    dot: "status-dot-running",
    dotClass: "bg-emerald-500",
    color: "#10b981",
    bar: "bg-emerald-500",
  },
  reduced: {
    label: "Redusert",
    icon: AlertTriangle,
    text: "text-amber-700 dark:text-amber-300",
    badge: "text-amber-700 dark:text-amber-300",
    dot: "status-dot-reduced",
    dotClass: "bg-amber-500",
    color: "#f59e0b",
    bar: "bg-amber-500",
  },
  stopped: {
    label: "Stanset",
    icon: PauseCircle,
    text: "text-rose-600 dark:text-rose-300",
    badge: "text-rose-600 dark:text-rose-300",
    dot: "status-dot-stopped",
    dotClass: "bg-rose-500",
    color: "#f43f5e",
    bar: "bg-rose-500",
  },
  maintenance: {
    label: "Vedlikehold",
    icon: Wrench,
    text: "text-sky-700 dark:text-sky-300",
    badge: "text-sky-700 dark:text-sky-300",
    dot: "status-dot-maintenance",
    dotClass: "bg-sky-500",
    color: "#0ea5e9",
    bar: "bg-sky-500",
  },
};

export const SEVERITY = {
  critical: { label: "Kritisk", icon: OctagonAlert, text: "text-rose-600 dark:text-rose-300", badge: "text-rose-600 dark:text-rose-300", color: "#e11d48", dotClass: "bg-rose-500" },
  warning: { label: "Advarsel", icon: AlertTriangle, text: "text-amber-700 dark:text-amber-300", badge: "text-amber-700 dark:text-amber-300", color: "#d97706", dotClass: "bg-amber-500" },
  info: { label: "Info", icon: Info, text: "text-muted-foreground", badge: "text-muted-foreground", color: "#64748b", dotClass: "bg-slate-400" },
};

export const EVENT_STATUS = {
  open: { label: "Åpen", badge: "border-rose-500/30 text-rose-600 dark:text-rose-300", dot: "bg-rose-500" },
  acknowledged: { label: "Kvittert", badge: "border-amber-500/30 text-amber-700 dark:text-amber-300", dot: "bg-amber-500" },
  resolved: { label: "Lukket", badge: "border-border text-muted-foreground", dot: "bg-muted-foreground/50" },
};

export const REQUEST_STATUS = {
  mottatt: { label: "Mottatt", badge: "border-sky-500/30 text-sky-700 dark:text-sky-300", dot: "bg-sky-500" },
  planlagt: { label: "Planlagt", badge: "border-primary/30 text-primary", dot: "bg-primary" },
  pagar: { label: "Pågår", badge: "border-amber-500/30 text-amber-700 dark:text-amber-300", dot: "bg-amber-500" },
  fullfort: { label: "Fullført", badge: "border-emerald-500/30 text-emerald-700 dark:text-emerald-300", dot: "bg-emerald-500" },
  avvist: { label: "Avvist", badge: "border-border text-muted-foreground", dot: "bg-muted-foreground/50" },
};

export const ROLE_LABEL = {
  proxima_admin: "Proxima-administrator",
  customer_admin: "Kunde-administrator",
  customer_user: "Bruker",
};
